import { render, staticRenderFns } from "./MinimalSalaryOverview.vue?vue&type=template&id=b4a8d27c&scoped=true"
import script from "./MinimalSalaryOverview.vue?vue&type=script&lang=js"
export * from "./MinimalSalaryOverview.vue?vue&type=script&lang=js"
import style0 from "./MinimalSalaryOverview.vue?vue&type=style&index=0&id=b4a8d27c&prod&lang=css"
import style1 from "./MinimalSalaryOverview.vue?vue&type=style&index=1&id=b4a8d27c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a8d27c",
  null
  
)

export default component.exports